import { render, staticRenderFns } from "./CoverFieldAttributes.vue?vue&type=template&id=b29fd46a&scoped=true"
import script from "./CoverFieldAttributes.vue?vue&type=script&lang=js"
export * from "./CoverFieldAttributes.vue?vue&type=script&lang=js"
import style0 from "./CoverFieldAttributes.vue?vue&type=style&index=0&id=b29fd46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29fd46a",
  null
  
)

export default component.exports